import { render } from "./Buildings.vue?vue&type=template&id=f324acc6&scoped=true"
import script from "./Buildings.vue?vue&type=script&lang=js"
export * from "./Buildings.vue?vue&type=script&lang=js"

import "./Buildings.vue?vue&type=style&index=0&id=f324acc6&scoped=true&lang=css"

import exportComponent from "/Users/siorikitajima/Dropbox (Personal)/Code/GCV/ga-emc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f324acc6"]])

export default __exports__